"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDriverLoanTerm = exports.getDriverMinCreditScore = exports.getDriverLoanAmount = exports.getDriverEstimatedApr = void 0;

var _personalLoans = require("../selectors/personal-loans");

var _loans = require("../utils/loans");

var _format = require("../utils/format");

var _drivers = require("../constants/drivers");

/**
 * @module
 *
 * @description Personal Loans selectors
 */

/**
 * Get the estimated APR driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */
var getDriverEstimatedApr = function getDriverEstimatedApr(offer) {
  return {
    id: 'estApr',
    label: 'Est. APR',
    value: (0, _format.getPercentageRange)((0, _personalLoans.getAprMin)(offer), (0, _personalLoans.getAprMax)(offer)),
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _personalLoans.getAprTooltip)(offer)
  };
};
/**
 * Get the min credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */


exports.getDriverEstimatedApr = getDriverEstimatedApr;

var getDriverLoanAmount = function getDriverLoanAmount(offer) {
  return {
    id: 'loanAmount',
    label: 'Loan amount',
    value: (0, _loans.getLoanAmountRange)(offer),
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _personalLoans.getLoanTermAnnotation)(offer)
  };
};
/**
 * Get the min credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */


exports.getDriverLoanAmount = getDriverLoanAmount;

var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  return {
    id: 'minCreditScore',
    label: 'Min. credit score',
    value: (0, _personalLoans.getFicoMin)(offer) || 'None',
    // do not respect 0
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _personalLoans.getFicoMinTooltip)(offer)
  };
};
/**
 * Get the loan term driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */


exports.getDriverMinCreditScore = getDriverMinCreditScore;

var getDriverLoanTerm = function getDriverLoanTerm(offer) {
  return {
    id: 'loanTerm',
    label: 'Loan term',
    value: (0, _loans.getAvailableTermLengths)(offer),
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    valueTooltip: (0, _personalLoans.getLoanTermAnnotation)(offer)
  };
};

exports.getDriverLoanTerm = getDriverLoanTerm;